/**
 * Get Tailwind color classes for Jira issue type badge
 */
export function getIssueTypeColor(issueType: string): string {
  const normalized = issueType.toLowerCase();
  if (normalized === 'epic')
    return 'bg-secondary-100 text-secondary-700 dark:bg-secondary-900/30 dark:text-secondary-300';
  if (normalized === 'bug')
    return 'bg-danger-100 text-danger-700 dark:bg-danger-900/30 dark:text-danger-300';
  if (normalized === 'story')
    return 'bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-300';
  if (normalized === 'subtask' || normalized === 'sub-task')
    return 'bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300';
  // Task and everything else: no specific category, so no specific hue —
  // neutral default badge rather than forcing an arbitrary color.
  return 'bg-default-100 text-default-700 dark:bg-default-900/30 dark:text-default-300';
}

/**
 * Get Tailwind color class for Jira priority level
 */
export function getPriorityColor(priority: string): string {
  const normalizedPriority = priority.toLowerCase();
  if (
    normalizedPriority === 'highest' ||
    normalizedPriority === 'high' ||
    normalizedPriority === 'critical'
  ) {
    return 'bg-error';
  }
  if (normalizedPriority === 'medium' || normalizedPriority === 'normal') {
    return 'bg-warning';
  }
  return 'bg-muted';
}

/**
 * Get Tailwind color classes for Jira status
 */
export function getStatusColor(status: string): string {
  const normalizedStatus = status.toLowerCase();
  if (
    normalizedStatus === 'done' ||
    normalizedStatus === 'resolved' ||
    normalizedStatus === 'closed'
  ) {
    return 'bg-success/20 text-success';
  }
  if (normalizedStatus.includes('progress') || normalizedStatus === 'in review') {
    return 'bg-primary/20 text-primary';
  }
  return 'bg-muted/20 text-muted';
}
